import { ScrollTrigger } from "gsap/ScrollTrigger";

/*
 * ScrollTrigger only auto-refreshes on window resize, but sections above a pin (the hero frame,
 * the Method rail, late images and fonts) change the page height too, leaving start/end stale.
 * Every section that cares watches its page through here, so one height change costs one
 * refresh, not one per section (each refresh re-measures every trigger on the page).
 */
const watched = new Map(); // element -> { ro, users, lastHeight }
let timer;
const idle = (cb) => (window.requestIdleCallback ? requestIdleCallback(cb, { timeout: 600 }) : setTimeout(cb, 0));

export function refreshOnHeightChange(el, delay = 100) {
  if (!el) return () => {};
  let entry = watched.get(el);
  if (!entry) {
    entry = { users: 0, lastHeight: el.offsetHeight };
    entry.ro = new ResizeObserver(() => {
      const height = el.offsetHeight;
      if (Math.abs(height - entry.lastHeight) < 1) return;
      entry.lastHeight = height;
      clearTimeout(timer);
      // a refresh re-measures every pin (one long frame), so run it once things have settled
      // and the browser is idle — e.g. after an FAQ panel finishes opening, not during it
      timer = setTimeout(() => idle(() => ScrollTrigger.refresh()), delay);
    });
    entry.ro.observe(el);
    watched.set(el, entry);
  }
  entry.users++;

  return () => {
    if (--entry.users > 0) return;
    entry.ro.disconnect();
    watched.delete(el);
    if (!watched.size) clearTimeout(timer);
  };
}
